export const TAB_BUILDS = 'builds';
export const TAB_TESTS = 'tests';
export const TAB_MANUAL = 'live';
export const TAB_ONBOARDING = 'onboarding';
export const TAB_NAMES = [TAB_BUILDS, TAB_TESTS, TAB_MANUAL, TAB_ONBOARDING];
export const DEFAULT_TAB_NAME = TAB_NAMES[0];
export const REAL_DEVICE_CLOUD = 'real_device_cloud';
export const VIRTUAL_DEVICE_CLOUD = 'virtual_device_cloud';
export const CLOUD_TYPES = [REAL_DEVICE_CLOUD, VIRTUAL_DEVICE_CLOUD];
export const DEFAULT_CLOUD_TYPE = VIRTUAL_DEVICE_CLOUD;
export const LS_LAST_CLOUD_TYPE = 'lastCloudTypeJobs';
export const API_FETCH_INTERVAL = 8000;
export const API_FETCH_THROTTLE = 500;
export const INITIAL_RDC_OFFSET = 1;
